import { atom } from 'recoil';

import { FilterModalTypes } from '../../../components/FilterModal';
import { OrderByModalTypes } from '../../../components/OrderByModal';

import { securitiesTransferAvailableFilter } from './constants';

export const securitiesTransferFiltersAtom = atom<FilterModalTypes.FilterAtom>({
  key: 'securitiesTransferDetails/filterSelections',
  default: {
    availableFilters: securitiesTransferAvailableFilter,
    selectedFilters: [],
    appliedFilters: [],
  },
});

export const securitiesTransferOrderByAtom = atom<OrderByModalTypes.OrderByAtom>({
  key: 'securitiesTransferOrderByAtom',
  default: {
    availableOrderBy: [],
    selectedOrderBy: undefined,
    appliedOrderBy: undefined,
  },
});
